import {
  FILE_UPLOAD_LOADING,
  FILE_UPLOAD_SUCCESS,
  FILE_UPLOAD_ERROR,
} from "./constains";
const initialState = {
  loading: false,
  errorMessage: {},
  mediaData: {},
};

export function mediaReducer(state = initialState, action) {
  switch (action.type) {
    case FILE_UPLOAD_LOADING:
      return {
        ...state,
        loading: true,
      };
    case FILE_UPLOAD_SUCCESS:
      return {
        ...state,
        mediaData: action.payload,
        loading: false,
      };
    case FILE_UPLOAD_ERROR:
      return {
        ...state,
        errorMessage: action.payload,
        loading: false,
      };
    default:
      return state;
  }
}
